// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2-AUa","buttons":"PendingPaymentAlert_buttons__RoJ8t"};